




























































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseFormulirCard from "@/BaseFormulirCard.vue";
import CommonFormulir, { EnFormulirCategory } from "@/services/CommonFormulir";
import BaseFormulir from "@/BaseFormulir";
import YaTidak from "@/components/pemeriksaan/tabs/rekam-medis/okupasi-terapi/YaTidak.vue";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";

import pdf from "vue-pdf";
import moment from "moment";
import FormulirAsesmenTerapiWicara from "@/store/modules/FormulirAsesmenTerapiWicara";

const SEKSI_ITEMS = [
  {
    judul: "1. Gangguan Bahasa",
    items: [
      { key: "bahasa_reseptif", label: "Bahasa Reseptif" },
      { key: "bahasa_ekspresif", label: "Bahasa Ekspresif" }
    ]
  },
  {
    judul: "2. Gangguan Bicara",
    items: [
      { key: "gangguan_artikulasi", label: "Gangguan Artikulasi" },
      { key: "tongue_tie", label: "Tongue Tie" }
    ]
  },
  {
    judul: "3. Gangguan Suara",
    items: [
      { key: "suara_sengau", label: "Suara Sengau" },
      { key: "suara_berbisik", label: "Suara Berbisik" }
    ]
  },
  {
    judul: "4. Irama Kelancaran",
    items: [
      { key: "gagap", label: "Gagap/Stuttering" },
      { key: "latah", label: "Latah/Cluttering" }
    ]
  },
  {
    judul: "5. Gangguan Menelan",
    items: [
      { key: "tersedak_makan", label: "Tersedak Saat Makan" },
      { key: "tersedak_minum", label: "Tersedak Saat Minum" },
      { key: "pakai_ngt", label: "Pakai NGT/OGT" }
    ]
  }
];

const BUTIR_KEYS = SEKSI_ITEMS.reduce(
  (acc, seksi) => acc.concat(seksi.items.map(i => i.key)),
  [] as string[]
);

@Component({
  components: {
    CardModalTtd,
    BaseFormulirCard,
    YaTidak,
    pdf
  }
})
export default class FormulirAsesmenTerapiWicaraTabPage extends BaseFormulir {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["11"];
  formSvc = new CommonFormulir(EnFormulirCategory.AsesmenTerapiWicara);
  formStore = FormulirAsesmenTerapiWicara;

  seksiItems = SEKSI_ITEMS;

  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  tglPemeriksaanShow = false;
  tglPemeriksaan = moment().format("YYYY-MM-DD");
  keluhan = null;
  riwayatSakit = null;
  butir: Record<string, string | null> = BUTIR_KEYS.reduce((acc, key) => {
    acc[key] = null;
    return acc;
  }, {} as Record<string, string | null>);
  diagnosaTw = null;
  rencanaTindakan = null;

  mounted() {
    this.changedataForm(this.dataForm);
  }

  get pdfUrl() {
    return this.dataForm
      ? this.getPdfUrl(EnFormulirCategory.AsesmenTerapiWicara, this.dataForm.id)
      : null;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.pasien.rm,
      unit_id: this.user.unit_id,
      surat_date: moment().format("YYYY-MM-DD"),
      signee_user_id: this.user.id,
      creator_user_id: this.user.id,
      content: Object.assign(
        {
          tgl_pemeriksaan: this.tglPemeriksaan,
          keluhan: this.keluhan,
          riwayat_sakit: this.riwayatSakit,
          diagnosa_tw: this.diagnosaTw,
          rencana_tindakan: this.rencanaTindakan
        },
        this.butir
      )
    };
  }

  setButir(key: string, val: string) {
    this.butir = Object.assign({}, this.butir, { [key]: val });
  }

  save() {
    if (this.saving) return;
    this.saving = true;

    const action = this.dataForm
      ? this.formSvc.update(this.dataForm.id, this.input)
      : this.formSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        this.formStore.getByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }

  tglPemeriksaanFormat() {
    return this.tglPemeriksaan
      ? moment(this.tglPemeriksaan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("dataForm")
  changedataForm(val) {
    const c = val ? val.content || {} : {};

    this.tglPemeriksaan = c.tgl_pemeriksaan || moment().format("YYYY-MM-DD");
    this.keluhan = c.keluhan || null;
    this.riwayatSakit = c.riwayat_sakit || null;
    this.diagnosaTw = c.diagnosa_tw || null;
    this.rencanaTindakan = c.rencana_tindakan || null;
    this.butir = BUTIR_KEYS.reduce((acc, key) => {
      acc[key] = c[key] || null;
      return acc;
    }, {} as Record<string, string | null>);
  }
}
